<template>
  <div id="page-settings-sync">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Παράμετροι Πεδίων Εισαγωγής</h2>
        <p>
          Αντιστοιχείστε τα παρακάτω πεδία με τα ονόματα του αρχείου XML ή του αρχείου Excel για την σωστή εισαγωγή των στοιχείων.
        </p>
      </vs-col>
    </vs-row>

    <div class="vx-card p-6">
      <validation-observer ref="productObserver" v-slot="{invalid}">
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>UID</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.uid"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>MPN</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.mpn"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>BARCODE</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.barcode"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>NAME</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.name"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>MAN/RER</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.manufacturer"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>STOCK</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.stock"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>COST</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.cost"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>PRICE</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.price"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>DISCOUNT</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.discount"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>

          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>CATEGORY</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.category"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>GROUP</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.group"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>LINK</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.link"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>IMAGE</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.image"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>

          </div>
          <vs-divider class="pb-5" />
          <div class="vx-col sm:w-1/3 w-full">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <span>Σύμβολο χιλιάδων</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.thousand_character"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <span>Σύμβολο δεκαδικών</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <validation-provider rules="required" v-slot="{errors}">
                  <vs-input class="w-full" v-model="item.decimal_character"/>
                  <div class="text-right text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
          </div>
          <vs-divider class="pb-5" />
          <div class="vx-col sm:w-1/3 w-full">
            <div class="vx-row mb-6">
              <vs-checkbox v-model="isChecked">Διατήρηση προϊόντων όταν αφαιρούνται από το XML</vs-checkbox>
            </div>
          </div>
          <vs-divider/>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button class="ml-4 mt-2" @click.prevent="saveSettings">Αποθήκευση</vs-button>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import axios from '@/axios.js'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο',
})
export default {
  data() {
    return {
      isChecked: false,
      item: {
        url: "",
        uid: "",
        mpn: "",
        barcode: "",
        name: "",
        link: "",
        stock: "",
        cost: "",
        price: "",
        discount: "",
        manufacturer: "",
        image: "",
        category: "",
        group: "",
        decimal_character : "",
        thousand_character: "",
        delete_from_xml: 0
      },
      apiEndpoint: localStorage.getItem('apiEndpoint'),
      token: localStorage.getItem('accessToken'),
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    checkboxValue() {
      return this.isChecked ? 1 : 0;
    },
  },
  methods: {
    getSettings() {
      let vm = this;
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.get('xmlOptions/list')
          .then((response) => {
            vm.item = response.data;
            vm.isChecked = vm.item.delete_from_xml === '1';
            vm.$vs.loading.close();
          })
          .catch((error) => {
            vm.$vs.loading.close();
          })
    },
    openConfirm() {
      let vm = this;
      if (!vm.item.url && !vm.xfilename) {
        this.saveSettings();
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Επιβεβαίωση`,
          acceptText: 'Αποδέχομαι',
          cancelText: 'Ακύρωση',
          text: 'Με την κίνηση αυτή θα σβηστούν όλα τα προϊόντα και θα ξαναπεραστούν από την πηγή που ορίσατε. Είστε σίγουρος;',
          accept: this.saveSettings
        })
      }
    },
    saveSettings() {
      {
        let vm = this;
        const formData = new FormData();
        vm.$vs.loading();
        formData.append('url', vm.item.url);
        formData.append('uid', vm.item.uid);
        formData.append('mpn', vm.item.mpn);
        formData.append('barcode', vm.item.barcode);
        formData.append('name', vm.item.name);
        formData.append('link', vm.item.link);
        formData.append('cost', vm.item.cost);
        formData.append('price', vm.item.price);
        formData.append('discount', vm.item.discount);
        formData.append('stock', vm.item.stock);
        formData.append('manufacturer', vm.item.manufacturer);
        formData.append('category', vm.item.category);
        formData.append('group', vm.item.group);
        formData.append('image', vm.item.image);
        formData.append('decimal_character', vm.item.decimal_character);
        formData.append('thousand_character', vm.item.thousand_character);
        formData.append('do_not_execute_upload', true);
        formData.append('delete_from_xml', vm.checkboxValue);
        axios.post("xmlOptions/update", formData)
            .then((response) => {
              vm.$vs.loading.close();
              vm.initiated = false;
              vm.$vs.notify({
                color: 'success',
                title: 'Οι αλλαγές αποθηκεύτικαν με επιτυχία',
                position: 'top-right',
                text: response.data.message //'The selected source configuration was successfully saved and new products have been parsed.'
              })
            })
            .catch((error) => {
              vm.$vs.loading.close();
              vm.$vs.notify({
                color: 'warning',
                title: 'Οι αλλαγές δεν αποθηκεύτικαν με επιτυχία',
                position: 'top-right',
                text: 'Παρουσιάστηκε κάποιο σφάλμα. Παρακαλώ ελέγξτε αν όλα τα πεδία έχουν συμπληρωθεί σωστά και ξαναπροσπαθήστε'
              })
            })
      }
    }
  },
  mounted() {
    let vm = this;
    vm.$vs.loading();
    vm.getSettings();
  }
}
</script>
<style scoped>
.vs-button-primary.vs-button-flat {
  font-size: 9px;
  padding: 5px !important;
}
</style>
